import { GridSortModel } from '@mui/x-data-grid';
import { TEntityListResponse, TCompanySummaryResBody } from '@poseidon-city/api-sdk';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { getQuerySortString } from '../device-types/list-device-by-device-type';

type TCompaniesListHook = {
  isError: boolean;
  isLoading: boolean;
  data: TEntityListResponse<'company', TCompanySummaryResBody> | undefined;
  refetch: () => void;
};

function useGetCompanies(limit: number, page: number, queryOptions: { sortModel: GridSortModel }): TCompaniesListHook {
  const sdk = useApiSDK();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const sortStr = getQuerySortString(queryOptions);

  const { isError, isLoading, data, refetch } = useQuery({
    queryKey: ['companies', limit, page, sortStr],
    queryFn: async () => {
      return await sdk.companies.list(limit, page, sortStr);
    },

    cacheTime: 0,
    staleTime: 0,
    keepPreviousData: false,
    refetchOnReconnect: 'always',

    onError: () => {
      localStorage.removeItem('areaId');
      localStorage.removeItem('companyId');
      localStorage.removeItem('refreshToken');
      sessionStorage.removeItem('accessToken');
      queryClient.clear();

      navigate('/login');
    },
  });
  return { isError, isLoading, data, refetch };
}

export { useGetCompanies };
